<div class="select__form" [ngClass]="{'p-1': !isWhiteBox, 'd-flex': display === 'horizontal'}">
  @if (selectLabel) {
    <label class="fw-medium p-1 so-primary" [style]="labelStyle" [ngClass]="display === 'horizontal' ? 'so-primary so-text-3-bold pe-3' : 'custom-reactive-select-label'">
      {{ selectLabel }} <app-so-required-mark [show]="requiredMark" [isValid]="touched && valid" />
    </label>
  }
  <div class="select-container" [ngClass]="{'white-box': isWhiteBox}">
    <div
      class="select-trigger custom-reactive-select form-select form-select-sm app-so-input-border w-100 text-truncate"
      [class.custom-reactive-select-arrow]="!isLoading"
      [class.disabled]="isDisabled"
      [style]="customStyle"
      cdkOverlayOrigin
      #triggerOrigin="cdkOverlayOrigin"
      #triggerRef
      role="combobox"
      [attr.aria-expanded]="isOpen"
      [attr.aria-disabled]="isDisabled"
      [attr.aria-controls]="panelId"
      aria-haspopup="listbox"
      [attr.aria-activedescendant]="activeOptionId"
      [attr.tabindex]="isDisabled ? -1 : 0"
      (click)="onTriggerClick()"
      (keydown)="onTriggerKeydown($event)"
      [matTooltip]="(tooltipDisabledText && isDisabled) ? tooltipDisabledText : ''"
      matTooltipPosition="above">
      @if (!currentDisplayItem) {
        <span class="placeholder">{{ 'selected' | translated : 'Seleccionar' : lang }}</span>
      }
      @if(currentDisplayItem){
        <span class="selected-value text-truncate">{{ currentDisplayItem }}</span>
      }
    </div>

    @if (currentDisplayItem !== null) {
      <span [class]="('display-value text-truncate ' + displayValueClass).trim()" [style]="displayValueStyle">{{ currentDisplayItem }}</span>
    }

    <ng-template
      cdkConnectedOverlay
      [cdkConnectedOverlayOrigin]="triggerOrigin"
      [cdkConnectedOverlayOpen]="isOpen"
      [cdkConnectedOverlayPositions]="overlayPositions"
      [cdkConnectedOverlayHasBackdrop]="true"
      [cdkConnectedOverlayBackdropClass]="'cdk-overlay-transparent-backdrop'"
      (backdropClick)="closePanel()"
      (detach)="closePanel()">
      <div
        class="options-panel"
        [@panelAnimation]="isOpen ? 'open' : 'closed'"
        role="listbox"
        [attr.id]="panelId"
        [style.height.px]="panelHeight"
        [style.max-height.px]="panelHeight"
        [style.width.px]="triggerWidth || null">
        <cdk-virtual-scroll-viewport
          class="options-viewport"
          [itemSize]="itemSize"
          [style.height.px]="panelHeight"
          [style.overflow-y]="viewportOverflowY"
          [minBufferPx]="itemSize"
          [maxBufferPx]="itemSize * 2">
          <div
            class="option-item"
            *cdkVirtualFor="let item of items; let index = index; trackBy: trackByKey"
            role="option"
            [attr.id]="getOptionId(index)"
            [attr.aria-selected]="normalizeKey(item.key) === normalizeKey(value)"
            [ngClass]="{
              selected: value !== null && (normalizeKey(item.key) === normalizeKey(value)),
              disabled: shouldBeDisabled(item.key),
              active: index === activeIndex
            }"
            (click)="selectItem(item)">
            {{ item.value | translate }}
          </div>
        </cdk-virtual-scroll-viewport>
      </div>
    </ng-template>

    @if (isLoading) {
      <div class="spinner"></div>
    }
  </div>
</div>
